import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './PremiumGuideCta.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function PremiumGuideCta({ post }) {
  const { user } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showEmailInput, setShowEmailInput] = useState(false);

  const handlePurchase = async () => {
    // If user is logged in, proceed directly
    if (user?.email) {
      await initiateCheckout(user.email);
      return;
    }

    // Otherwise, show email input
    if (!showEmailInput) {
      setShowEmailInput(true);
      return;
    }

    // Validate email
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email');
      return;
    }

    await initiateCheckout(email);
  };

  const initiateCheckout = async (customerEmail) => {
    setLoading(true);
    setError(null);

    try {
      const headers = {
        'Content-Type': 'application/json'
      };
      const token = localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`${API_URL}/guides/checkout`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          blogPostId: post._id,
          email: customerEmail
        })
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.alreadyPurchased) {
          // Redirect to download
          window.location.href = `/guides/download/${data.downloadToken}`;
          return;
        }
        throw new Error(data.message || 'Failed to start checkout');
      }

      // Redirect to Stripe
      window.location.href = data.url;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!post.hasPremiumPdf) return null;

  const price = post.premiumPrice || 7.99;

  return (
    <div className="premium-guide-cta">
      <div className="premium-guide-badge">📘 Premium Guide</div>
      
      <h3>{post.premiumTitle || `The Complete Guide to ${post.title}`}</h3>
      
      <p className="premium-description">
        {post.premiumDescription || 'Get the comprehensive PDF guide with everything you need to know.'}
      </p>
      
      {post.premiumPreviewPoints?.length > 0 && (
        <ul className="premium-points">
          {post.premiumPreviewPoints.map((point, idx) => (
            <li key={idx}>✓ {point}</li>
          ))}
        </ul>
      )}
      
      <div className="premium-pricing">
        <span className="premium-price">${price.toFixed(2)}</span>
        <span className="premium-format">PDF Download</span>
      </div>

      {error && <div className="premium-error">{error}</div>}

      {showEmailInput && !user && (
        <div className="premium-email-input">
          <input
            type="email"
            placeholder="Enter your email for delivery"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>
      )}

      <button 
        className="premium-buy-btn" 
        onClick={handlePurchase}
        disabled={loading}
      >
        {loading ? 'Processing...' : (
          showEmailInput && !user ? 'Continue to Checkout' : 'Get the Complete Guide'
        )}
      </button>

      <p className="premium-note">
        Instant download • Secure payment via Stripe
      </p>
    </div>
  );
}

export default PremiumGuideCta;
